import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import load from 'ember-async-data/helpers/load';
import t from 'ember-intl/helpers/t';
import and from 'ember-truth-helpers/helpers/and';

import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import SftpUser from 'umg-ember-backend/components/ui/sftp-user';
import Window from 'umg-ember-backend/components/ui/window';
import greeting from 'umg-ember-backend/helpers/greeting';

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:title>
      {{greeting @controller.model.person}}
    </:title>

    <:body>
      <Form
        @disableRegisterToBreadcrumb={{true}}
        @model={{@controller.model}}
        as |form|
      >
        <div class='o-layout'>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            <form.fieldset @titleKey='general' as |fieldset|>
              {{#let (load @controller.model.person) as |result|}}
                {{#if (and result.isResolved result.value)}}
                  <Form
                    @disableRegisterToBreadcrumb={{true}}
                    @model={{result.value}}
                    as |subform|
                  >
                    <subform.field @property='firstname' @disabled={{true}} />
                    <subform.field @property='lastname' @disabled={{true}} />
                  </Form>
                {{/if}}
              {{/let}}

              <fieldset.field @property='name' @disabled={{true}} />
              <fieldset.field @property='pass' @type='password' />

              <Button
                @disabled={{@controller.isModelDisabledOrInvalid}}
                @label={{t 'profile.save'}}
                {{on 'click' (fn @controller.saveUser form.model)}}
              />
            </form.fieldset>
          </div>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            {{#let (load @controller.model.sftpUsers) as |result|}}
              {{#if (and result.isResolved result.value)}}
                <form.fieldset @titleKey='sftpUsers' @isVisible={{true}}>
                  {{#each result.value as |sftpUser|}}
                    <SftpUser
                      @user={{sftpUser}}
                      @saveSftpUser={{@controller.saveSftpUser}}
                      @generateNewPassword={{@controller.generateNewPassword}}
                    />
                  {{/each}}
                </form.fieldset>
              {{/if}}
            {{/let}}
          </div>
        </div>
      </Form>
    </:body>
  </Window>
</template>
